/*eslint-disable*/
import React, { useEffect, useState } from 'react'
import { Header, Segment, } from 'semantic-ui-react'
import LoadingPlaceholder from '../../placeholderComponent/loadingPlaceholder'
import AgGridTable from '../../agGridComponent/agGridTable';
import ActionButton from './actionButton';
import APP_CONSTANTS from '../../../config/constants';
import Axios from 'axios';
import moment from 'moment';
import { branchHeaders } from '../../../utils/constants/branch.constants';
import { tableHeaders,tableMessage } from '../../../utils/constants/table.constants';
import { FEATURES } from '../../../utils/constants';


function BranchTable(props) {
    const [branches, setbranches] = useState([])
    const [isLoading, setisLoading] = useState(true)
    const [isUpdated, setisUpdated] = useState(false)
    useEffect(() => {
        getData()
    }, [isUpdated])

    let getData = () => {
        let token = localStorage.getItem('apiToken')
        let userId = localStorage.getItem('userId')
        let customerNo = localStorage.getItem('customerNo')
        let data = JSON.stringify
            ({
                customerNumber: customerNo,
                userId: userId,
            })
        // console.log(APP_CONSTANTS)
        Axios.post(`${APP_CONSTANTS.BASE_URL}masters/branch`, data, {
            headers: {
                'Content-Type': 'application/json',
                "Authorization": token,
                "Access-Control-Allow-Origin": "*" 
            }
        }).then((response => {
            // console.log(response.data.data)
            setbranches(response.data.resultSet)
            setisLoading(false)
        }))
        .catch(error => console.log(error))
        // ReadAxios({ url: 'masters/branch' }).then((result) => {
        //     setbranches(result)
        //     setisLoaded(true)
        // })
    }
    let getUpdate = (data) => {
        if (data) {
            setisUpdated(!isUpdated)
        }
    }
    // if (branches.length === 0 && isLoaded === false) {
    //     return (
    //         <LoadingPlaceholder />
    //     )
    // } else if (branches.length === 0) {
    //     return (
    //         <Segment className="m-2">
    //             <center> <Header>{tableMessage.NO_RECORD}</Header></center>
    //         </Segment>
    //     )
    // } else {

        let columnDefs = [
            { headerName: branchHeaders.BRANCH_CODE, field: 'code', tooltipField: 'code', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: branchHeaders.BRANCH_NAME, field: 'name', tooltipField: 'name', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: tableHeaders.CREATED_BY, field: 'cby', tooltipField: 'cby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: tableHeaders.CREATED_DATE, field: 'cdate', tooltipField: 'cdate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: tableHeaders.UPDATED_BY, field: 'uby', tooltipField: 'uby', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: tableHeaders.UPDATED_DATE, field: 'udate', tooltipField: 'udate', enableRowGroup: true, enablePivot: true, filter: true },
            { headerName: tableHeaders.EDIT_DELETE, field: 'edit', cellRenderer: 'actionRenderer', suppressToolPanel: true, },
        ]
        let rowData = []
        branches.map((object, i) => {
            let temp = {}
            temp.code = object.branchCode.toUpperCase()
            temp.name = object.branchName ? object.branchName : null
            temp.cby = object.createdByUserName ? object.createdByUserName : null
            temp.id = object.branchId ? object.branchId : null
            temp.cdate = object.createdOn ? moment(object.createdOn).format('DD-MM-yyyy') : null
            temp.uby = object.updatedByUserName ? object.updatedByUserName : null
            temp.udate =  object.updatedOn ? moment(object.updatedOn).format('DD-MM-yyyy') : null
            temp.isGSTExempted = object.isGSTExempted ? object.isGSTExempted : null
            temp.customerNo = object.customerNo ? object.customerNo : null
            temp.url = 'branch/delete'
            temp.deleteId = { branchId: object.branchId }
            rowData[i] = temp
        })
        return (
            <React.Fragment >
                <AgGridTable
                    columnDefs={columnDefs}
                    rowData={rowData}
                    isLoading={isLoading}
                    searchValue={props.searchValue}
                    actionButton={ActionButton}
                    reload={getUpdate}
                    link="#"
                    hiddenNew={true}
                    newPopup={props.newPopup}
                    titleBarTitle="Branch"
                    handleSearch={props.handleSearch}
                    hiddenImportPopupBtn={true}
                    showImport={true}
                    fileName="branchMaster"
                    importSubUrl={'masters/import/branchMaster'}
                    exportHidden={FEATURES.mastersExportDisabled()}
                    suppressExcelExport={FEATURES.mastersExportDisabled()}
                    suppressCsvExport={FEATURES.mastersExportDisabled()}
                />
            </React.Fragment>
        )
    //}

}

export default BranchTable
